import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  flex: 1;
  width: 100%;

  &.project-map {
    margin: 0px var(--size-lg) var(--size-lg) var(--size-lg);
    width: calc(100% - 48px);
  }

  .risk-selector {
    &.first {
      .ant-slider-track {
        background: linear-gradient(to right,
          #73D13D 0%, #FADB14 24.3%, #FA8C16 47.4%, #FA8C16 72.05%, #CF1322 100%);
      }
    }

    &.second {
      .ant-slider-track {
        background: linear-gradient(to right,
          #73D13D 0%, #FADB14 33%, #FA8C16 66%, #FA8C16 100%);
      }
    }

    &.third {
      .ant-slider-track {
        background: linear-gradient(to right,
          #73D13D 0%, #FADB14 50%, #FA8C16 100%);
      }
    }

    &.fourth {
      .ant-slider-track {
        background: linear-gradient(to right,
          #73D13D 0%, #FADB14 100%);
      }
    }

    &.fifth {
      .ant-slider-track {
        background: linear-gradient(to right,
          #FADB14 0%, #FA8C16 33%, #FA8C16 66%, #CF1322 100%);
      }
    }

    &.sixth {
      .ant-slider-track {
        background: linear-gradient(to right,
          #FADB14 0%, #FA8C16 33%, #FA8C16 66%, #CF1322 100%);
      }
    }

    &.seventh {
      .ant-slider-track {
        background: linear-gradient(to right,
          #FADB14 0%, #FA8C16 100%);
      }
    }

    &.eigth {
      .ant-slider-track {
        background: linear-gradient(to right,
           #FA8C16 0%, #FA8C16 50%, #CF1322 100%);
      }
    }

    &.ninth {
      .ant-slider-track {
        background: linear-gradient(to right,
          #FA8C16 0%, #FA8C16 50%, #CF1322 100%);
      }
    }

    &.tenth {
      .ant-slider-track {
        background: linear-gradient(to right,
          #FA8C16 0%, #CF1322 100%);
      }
    }
    .risk-range{
      display: flex;
      justify-content: space-between;
      width: 100%;
      .range-container{
        display: flex;
        flex-direction: column;
        label {
          margin-bottom: 0.1rem;
        }
        .input-number{
          width: 60px
        }
      }
    }
  }

  .leaflet-popup-content {
    margin: 0 16px;
    width: auto !important;
    min-width: 80px;

    h5 {
      margin-bottom: 0;
    }
  }

  .custom-popover {
    width: 230px;

    .list {
      display: flex;
      flex-direction: column;
      color: #595959;
      font-weight: 600;
      margin-top: 5px;

      .item {
        padding-top: 8px;
        padding-bottom: 8px;
        border-top: 1px solid #E1E1E1;
        border-bottom: 1px solid #E1E1E1;
        margin-top: -1px;
        display: flex;

        .main {
          flex: 1;

          img {
            margin-right: 6px;
          }
        }
      }
    }
  }

  .map-marker {
    text-align: center;
    width 100%;
    height: 100%;
    border-radius: 50% 50% 50% 0;;

    .main {
      width: 100% !important;
      height: 100% !important;
      border-radius: 50% 50% 50% 0;
    }

    &.incident, &.other-event {
      .main {
        border-radius: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: white;
      }
    }

    &.location {
      .main {
        transform: rotate(-45deg);
        border: 2px solid white;
      }

      &.minesites-location {
        border-radius: 50% 50% 50% 0;;

        .main {
          background: var(--color-primary-20);
          border-radius: 50% 50% 50% 0;;
        }
      }

      &.villages-location {
        border-radius: 50% 50% 50% 0;;
        .main {
          background: var(--color-primary-40);
          border-radius: 50% 50% 50% 0;;
        }
      }

      &.other-location {
        border-radius: 50% 50% 50% 0;;
        .main {
          background: var(--color-primary-60);
          border-radius: 50% 50% 50% 0;;
        }
      }
    }
  }

  .legend {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 100px;
    border-right: 1px solid #CCCCCC;
    .group {
      display: flex;
      flex-direction: column;
      padding: var(--size) 12px;
      border-bottom: 1px solid #CCCCCC;

      h1 {
        color: #595959;
        font-size: 14px;
        line-height: 22px;
		    font-family: SF UI Display;
        margin-bottom: 12px;
      }
      span {
        font-size: 15px;
        line-height: 25px;
        color: #000000;
        padding-left: 20px;
        position: relative;
        cursor: pointer;
        transition: .4s opacity;
      }
      span[shape="square"] {
        &::after {
          content: '';
          width: 8px;
          height: 8px;
          position: absolute;
          background: var(--color);
          top: -2.5px;
          left: 0;
          bottom: 0;
          margin: auto;
        }
      }
      span[shape="circle"] {
        &::after {
          content: '';
          width: 8px;
          height: 8px;
          position: absolute;
          background: var(--color);
          top: -2.5px;
          left: 0;
          bottom: 0;
          margin: auto;
          border-radius: 50%;
        }
      }
      span[shape="rect"] {
        &::after {
          content: '';
          display: block;
          position: absolute;
          left: 0;
          top: -2.5px;
          bottom: 8px;
          width: 0;
          height: 0;
          margin: auto;
          border-bottom: 8px solid var(--color);
          border-top: 8px solid transparent;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
        }
      }
    }
  }
  #map {
    width: 100%;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1;
    .leaflet-bottom.leaflet-right {
      display: none;
    }
    button {
      position: absolute;
      z-index: 999;
      top: var(--size-lg);
      left: var(--size-lg);
      box-shadow: 0px 4px 8px 0px #00000040;
      display: flex;
      align-items: center;
    }
  }

  .map-control-buttons {
    position: absolute;
    bottom: var(--size-lg);
    right: var(--size-lg);
    z-index: 1;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 4px 8px 0px #0000001A;

    button {
      width: 32px;
      height: 32px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background: white;
      outline: none;
      border: none;
      border-radius: 7px;
      &:not(:last-of-type) {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: 1px solid var(--base-gray-40);
      }
      &:not(:first-of-type) {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }
  }
`;

export const MapFilters = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: white;
  border-radius: 3px;
  position: absolute;
  z-index: 1020;
  top: 62px;
  left: 24px;
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
  width: 204px;
  -webkit-user-select: none;  
  -moz-user-select: none;    
  -ms-user-select: none;      
  user-select: none;

  label {
    color: var(--base-gray-70);
  }

  .ant-checkbox-group, .ant-radio-group {
    label {
      color: var(--base-gray-90);
    }
  }

  .checkbox-container {
    display: flex;

    span {
      flex: 1;
    }
  }

  .content {
    padding: var(--size-sm);
    font-weight: 400;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    
    .ant-checkbox-wrapper, .ant-radio-wrapper {
      font-size: 14px;
      font-weight: 400;
    }
    .ant-select {
      margin-bottom: 12px;
    }
  }
`;
